import React, { useCallback, useState } from 'react'
import { Avatar, Modal, Button, Radio, Descriptions, message } from 'antd'
import IconFont from '../../iconFont/IconFont'
import './Styles.css'

const SairDaFila = ({ visible, onCancel, onSubmit, vendedor }) => {
  const [name, setName] = useState()
  const [loading, setLoading] = useState(false)

  const valueOptions = [
    { type: 'home', value: 'casa' },
    { type: 'lunch', value: 'almoço' },
    { type: 'coffee', value: 'café' },
    { type: 'street-view', value: 'outro' },
  ]

  const handleRadioGroupChange = useCallback(
    ({ target }) => {
      const findTarget = valueOptions.find(value => value.type === target.value)

      setName(findTarget.type)
    },
    [valueOptions],
  )

  const handleOk = async () => {
    if (!name) {
      message.warning('Escolha o motivo da sua saída')
      return
    }
    setLoading(true)
    const razao = valueOptions.filter(item => item.type === name)[0]
    await onSubmit(razao)
    setLoading(false)
    setName(undefined)
  }

  const handleCancel = () => {
    setLoading(false)
    onCancel()
  }

  return (
    <div>
      <Modal
        title='Por que deseja sair da fila?'
        open={visible}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <div className='sair-fila-wrapper'>
          <Avatar
            src={vendedor.avatar}
            size={80}
            className='avatarSaidaVendedor'
            shape='circle'
          />

          <div className='apelido-vendedor'>{vendedor.apelido}</div>

          <div className='motivos-container'>
            {valueOptions.map(({ type, value }) => (
              <div
                key={type}
                className={`motivo-card ${name === type ? 'selected' : ''}`}
                onClick={() => setName(type)}
              >
                <IconFont type={type} size={28} />
                <span>{value.charAt(0).toUpperCase() + value.slice(1)}</span>
              </div>
            ))}
          </div>

          <div className='botoes-fim'>
            <Button onClick={handleCancel} disabled={loading}>
              Cancelar
            </Button>
            <Button
              type='primary'
              danger
              disabled={loading}
              loading={loading}
              onClick={handleOk}
            >
              {loading ? 'Saindo...' : 'Confirmar saída'}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SairDaFila
